import { saveAs } from 'file-saver'

/* @ngInject */
function RenderVideoController ($scope, $q, $rootScope, $timeout, $location, $translate, SocketService, ArtsService, ModalService, UdsModalService) {
  let isCollapsed = false
  $scope.chevronDirection = 'chevron-down'
  $scope.showCloseButton = false
  $scope.materialText = $translate.instant('art').toLowerCase()
  $scope.renderingArts = []

  const getBusinessDataListDialogController = () => $q.when(import('../../../arts/dialogs/business-data/list/business-data-list-dialog.controller'))

  const getDownloadDialogController = () => $q.when(import('../../../arts/dialogs/download/download-dialog.controller'))

  activate()

  function activate () {
    SocketService.connectSocket('RenderVideo')
  }

  const openDownloadDialog = (art) => () => {
    getDownloadDialogController().then(({ DownloadDialogController }) => {
      const downloadDialog = UdsModalService.createModal({
        controller: DownloadDialogController,
        modalName: 'downloadDialog',
        data: {
          _iArtId: art.id,
          _sDownloadOption: art.downloadOption,
          _customizationLevel: art.customizationLevel,
          _isCustomizable: art.isCustomizable,
          _iProductId: art.productId,
          _oTemplate: {
            ...art,
            details: {
              suggestions: art.suggestions,
              instructions: art.instructions
            }
          }
        }
      })

      downloadDialog.open()
    })
  }

  const shouldShowCloseButton = () => {
    $timeout(() => {
      const hasCompleteDownload = $scope.renderingArts.every((art) => parseInt(art.progress) >= 100)

      if (hasCompleteDownload) {
        $scope.showCloseButton = true
      } else {
        $scope.showCloseButton = false
      }
    }, 100, false)
  }

  $rootScope.$on('$locationChangeSuccess', () => {
    if ($location.url().includes('login')) {
      $scope.close()
    }
  })

  $scope.$watchCollection('renderingArts', () => {
    if ($scope.renderingArts.length > 1) {
      $scope.materialText = $translate.instant('materials').toLowerCase()
    } else {
      $scope.materialText = $translate.instant('art').toLowerCase()
    }

    shouldShowCloseButton()
  })

  $scope.close = () => {
    $scope.renderingArts = []
  }

  $scope.collapseCard = () => {
    const cardBody = document.querySelector('.rendering-card .rendering-main')
    isCollapsed = !isCollapsed
    $scope.chevronDirection = isCollapsed ? 'chevron-up' : 'chevron-down'
    cardBody.style.display = isCollapsed ? 'none' : ''
  }

  const renderingEvent = (renderingArt) => {
    if (!renderingArt.videoPreview) {
      $scope.$apply(() => {
        let artIndex = $scope.renderingArts.findIndex(art => art.processId === renderingArt.processId)

        if (artIndex === -1 && renderingArt.processId) {
          $scope.renderingArts.push(renderingArt)
          artIndex = $scope.renderingArts.length - 1
        }
        $scope.renderingArts[artIndex] = renderingArt
      })
    } else {
      const progressBar = document.querySelector(`.progress-bar-${renderingArt.artId}`)

      if (progressBar) {
        progressBar.style.width = `${renderingArt.progress}%`
      }
    }

    if (renderingArt.progress >= 100) {
      setTimeout(() => {
        if (renderingArt.external) {
          const blob = new Blob([renderingArt.buffer], { type: 'mp4' })
          const fileExtension = 'mp4'

          const fileName = renderingArt.name + '.' + fileExtension
          saveAs(blob, fileName)
        } else {
          if (!renderingArt.videoPreview) {
            ArtsService.downloadArt(renderingArt.artId, 'mp4', 'mp4')
          }
        }

        shouldShowCloseButton()
      }, 1000)
    }
  }

  const deregisterSocketConnected = $rootScope.$on('socket-connected-successfully-RenderVideo', () => {
    SocketService.registerEvent('renderError', (error) => {
      if (error) {
        getBusinessDataListDialogController().then(({ BusinessDataListDialogController }) => {
          ModalService.showModal({
            templateId: 'businessDataListDialog.html',
            templateUrl: '/arts/dialogs/business-data/list/business-data-list-dialog.html?$$REVISION$$',
            destroyable: true,
            observeChanges: true,
            allowMultiple: false,
            controller: BusinessDataListDialogController,
            data: {
              emptyMode: {
                type: 'secondary'
              },
              page: 'download',
              downloadArtFn: openDownloadDialog(error.art),
              placeholdersInUse: error || []
            }
          })
        })
      }
    }, 'RenderVideo')

    SocketService.registerEvent('rendering', renderingEvent, 'RenderVideo')
  })

  const deregisterExternalSocketConnected = $rootScope.$on('socket-connected-successfully-ExternalRenderVideo', () => {
    SocketService.registerEvent('rendering', renderingEvent, 'ExternalRenderVideo')
  })

  $scope.$on('$destroy', () => {
    deregisterSocketConnected()
    deregisterExternalSocketConnected()
  })
}

export { RenderVideoController }
